import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const categoriaFormularioImporterSelectors = importerSelectors(
  'categoriaFormulario.importer',
);

export default categoriaFormularioImporterSelectors;
